export const InstantAdvancesState = {
    pitchData: {
        data: {},
        isFetching: false,
        error: false
    }
};